/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Fac_Btn2Inputs */

const en_dr_room_fac_btn2 = /** @type {(inputs: Dr_Room_Fac_Btn2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Challenge`)
};

const id_dr_room_fac_btn2 = /** @type {(inputs: Dr_Room_Fac_Btn2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tantang`)
};

/**
* | output |
* | --- |
* | "Challenge" |
*
* @param {Dr_Room_Fac_Btn2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_fac_btn2 = /** @type {((inputs?: Dr_Room_Fac_Btn2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Fac_Btn2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_fac_btn2(inputs)
	return en_dr_room_fac_btn2(inputs)
});